import React, { useEffect, useState } from "react";
import GenericModal from "../../../Ui/Modal";
import ButtonComponent from "../../../Ui/Button";
import { Property } from "../../../../service";
import useApiHandler from "../../../hooks/ApiHandler";
import { toast } from "react-hot-toast";

const InputField = ({ label, type = "text", value, onChange, placeholder }) => (
  <div className="mb-0">
    <label className="block text-[12px] leading-[18px] font-semibold text-[#333333] mb-1">
      {label}
    </label>
    <input
      type={type}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      className="w-full max-w-[196px] min-w-[196px] bg-[#F8F8F8] font-neue-haas rounded-[8px] px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-green-500"
    />
  </div>
);

const EditFamily = ({ setModalState, propertyId, setPropertyId, onInvite }) => {
  const { callApi } = useApiHandler();
  const [familyMembers, setFamilyMembers] = useState([]);

  const handleClose = () => {
    setPropertyId(null);
    setModalState("");
  };

  const fetchFamily = () => {
    if (!propertyId) return;
    callApi(() => Property.getPropertyById(propertyId), {
      onSuccess: (res) => {
        const list = res.data?.family_members || [];
        // Normalize
        const normalized = list.map((m, idx) => ({
          id: m.id ?? idx,
          full_name: m.full_name || "",
          email: m.email || "",
          phone_number: m.phone_number || "",
        }));
        setFamilyMembers(normalized);
      },
      onError: (error) => {
        console.error("Error fetching family members:", error);
      },
      errorMessage: "Failed to fetch family members",
    });
  };

  useEffect(() => {
    fetchFamily();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [propertyId]);

  const handleUpdate = (id, field, value) => {
    setFamilyMembers((prev) =>
      prev.map((m) => (m.id === id ? { ...m, [field]: value } : m))
    );
  };

  const handleSaveRow = async (idx) => {
    // No API available yet; simulate save
    toast.success("Family member saved");
  };

  const handleInviteRow = (idx) => {
    if (!onInvite) return;
    const m = familyMembers[idx];
    onInvite([{ name: m.full_name, email: m.email }]);
  };

  const handleInviteAll = () => {
    if (!onInvite) return;
    const members = familyMembers.map((m) => ({ name: m.full_name, email: m.email }));
    onInvite(members);
  };

  return (
    <div>
      <GenericModal
        maxWidth="966px"
        open={true}
        onClose={handleClose}
        title="Edit Family Members"
        footer={
          <div className="flex w-full sm2:gap-4 gap-2 justify-between sm2:flex-row flex-col ">
            <ButtonComponent
              fontSize="14px"
              bgColor="#52C1711A"
              color="#52C171"
              borderColor="#52C171"
              paddingY="10px"
              onClick={() => setModalState("addFamilyMember")}
            >
              Add Family Member
            </ButtonComponent>
            <div className="flex justify-between sm2:gap-4 gap-2 sm2:flex-row flex-col">
              <ButtonComponent fontSize="14px" onClick={() => setModalState("addProperty")} paddingY="10px">
                Edit Property Details
              </ButtonComponent>
              <ButtonComponent
                fontSize="14px"
                bgColor="#3CAB5C"
                color="#FFFFFF"
                paddingY="10px"
                onClick={handleInviteAll}
                disabled={!familyMembers.length}
              >
                Invite All
              </ButtonComponent>
            </div>
          </div>
        }
      >
        <div className="p-4">
          {familyMembers.length === 0 ? (
            <div className="text-center py-8 text-[#595959]">
              <p className="text-[16px] font-[500]">No family members yet</p>
              <p className="text-[14px] mt-2">Add one to get started</p>
            </div>
          ) : (
            <div className="flex flex-col gap-4">
              {familyMembers.map((member, index) => (
                <div key={member.id} className="flex items-end justify-between gap-3 bg-[#F8F8F8] p-3 rounded-[8px]">
                  <div className="flex flex-wrap gap-3">
                    <InputField
                      label="Name"
                      value={member.full_name}
                      onChange={(e) => handleUpdate(member.id, "full_name", e.target.value)}
                      placeholder="Enter name"
                    />
                    <InputField
                      label="Phone Number"
                      value={member.phone_number}
                      onChange={(e) => handleUpdate(member.id, "phone_number", e.target.value)}
                      placeholder="Enter phone"
                    />
                    <InputField
                      type="email"
                      label="Email"
                      value={member.email}
                      onChange={(e) => handleUpdate(member.id, "email", e.target.value)}
                      placeholder="Enter email"
                    />
                  </div>
                  <div className="flex gap-2">
                    <ButtonComponent paddingY="8px" bgColor="#FFFFFF" color="#242424" onClick={() => handleSaveRow(index)}>
                      Save
                    </ButtonComponent>
                    <ButtonComponent paddingY="8px" onClick={() => handleInviteRow(index)}>
                      Invite
                    </ButtonComponent>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </GenericModal>
    </div>
  );
};

export default EditFamily;

